<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>Approval Feedback</h4>
        <p>What salespeople answered on the approval emails: approved as written, edited (both versions), or suspended with a reason.
          Use the edits to improve the standard wording (Follow-up Emails › Email wording).</p>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fbFrom">From</label>
            <Calendar id="fbFrom" v-model="from" dateFormat="dd/mm/yy" :showIcon="true" />
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fbTo">To</label>
            <Calendar id="fbTo" v-model="to" dateFormat="dd/mm/yy" :showIcon="true" />
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fbAction">Answer</label>
            <Dropdown id="fbAction" v-model="actionFilter" :options="actionOptions" optionLabel="label" optionValue="value" />
          </div>
          <div class="p-field p-col-12 p-md-2 p-as-end">
            <Button id="fbSearch" label="Show" icon="pi pi-search" @click="load" />
          </div>
        </div>
        <p v-if="data" id="fbCounts">{{ counts }}</p>
        <DataTable :value="rows" :loading="loading" dataKey="id" class="p-datatable-sm" emptyMessage="No answers in this period.">
          <Column field="createdAt" header="When" />
          <Column header="Quote">
            <template #body="slot"><router-link :to="'/enquiries/' + slot.data.oppId + '/followup'">{{ slot.data.quoteRef }}</router-link></template>
          </Column>
          <Column field="userName" header="Salesperson" />
          <Column header="Answer">
            <template #body="slot">{{ answer(slot.data) }}</template>
          </Column>
          <Column field="reason" header="Reason" />
          <Column header="" :styles="{ width: '7rem' }">
            <template #body="slot">
              <Button v-if="slot.data.action === 'EDIT'" :id="'fbView' + slot.data.id" label="Compare" class="p-button-text p-button-sm" @click="viewing = slot.data" />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <Dialog :visible="!!viewing" @update:visible="v => { if (!v) viewing = null }" header="Generated text and the salesperson's edit"
      :modal="true" :style="{ width: '900px' }" :contentStyle="{ maxHeight: '70vh', overflowY: 'auto' }">
      <div v-if="viewing" class="p-grid" id="fbCompare">
        <div class="p-col-6"><h6>Generated</h6><b>{{ viewing.originalSubject }}</b><pre class="fb-body">{{ viewing.originalBody }}</pre></div>
        <div class="p-col-6"><h6>Sent instead</h6><b>{{ viewing.editedSubject }}</b><pre class="fb-body">{{ viewing.editedBody }}</pre></div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import FollowupService, { errorMessage } from '@/service/FollowupService'
import { feedbackAnswer, feedbackCounts, ukDay } from './approvalFeedback'

export default {
  name: 'ApprovalFeedback',
  data() {
    var now = new Date()
    return {
      followupService: new FollowupService(),
      from: new Date(now.getFullYear(), now.getMonth(), 1),
      to: now,
      actionFilter: null,
      actionOptions: [{ value: null, label: 'All' }, { value: 'APPROVE', label: 'Approved' }, { value: 'EDIT', label: 'Edited' }, { value: 'SUSPEND', label: 'Suspended' }],
      data: null,
      loading: false,
      viewing: null
    }
  },
  computed: {
    rows() {
      var r = (this.data && this.data.rows) || []
      return this.actionFilter ? r.filter(x => x.action === this.actionFilter) : r
    },
    counts() { return feedbackCounts((this.data && this.data.rows) || []) }
  },
  created() { this.load() },
  methods: {
    answer: feedbackAnswer,
    load() {
      this.loading = true
      return this.followupService.approvals(ukDay(this.from), ukDay(this.to))
        .then(d => { this.data = d })
        .catch(err => { this.$toast.add({ severity: 'error', summary: 'Not loaded', detail: errorMessage(err, 'The answers could not be loaded.'), life: 5000 }) })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.fb-body { white-space: pre-wrap; font-family: inherit; background: #f8f9fa; padding: 0.5rem; }
</style>
